import { Spine } from '@esotericsoftware/spine-pixi-v8';
import {
    BitmapText,
    Container, /*Sprite,*/ Graphics
} from 'pixi.js';
import { Tween /*, Group/*, Easing*/ } from "tweedle.js";
import { /*getSymbol,*/ getSpineSymbol /*, isOversizeSymbol*/ } from "../config/getSymbol";
import { RespinIndex } from '../config/GlobalVariableConfig';
import { spinData } from '../server/getServerResposesFun';
// import { /*spinResponse,*/ initData/*, SpinDataObject/*, spinData /*, WinObject*/ } from '../server/getServerResposesFun'


import {
    REEL_DIVIDER,
    REEL_FRAME,
    REEL_NUMBERS,
    REEL_WIDTH,
    SYMBOL_HEIGHT,
    SYMBOL_WIDTH,
    // REEL_COLLECTION_COUNT,
    SYMBOLS_PER_REEL,
} from "../config/reelConfig";

const reelSymbols = [
    [3, 6, 1, 3, 6, 8, 3, 6, 3, 6, 8, 1, 6, 3, 8, 6, 1, 6, 8, 3, 6, 1, 3, 8, 6, 1, 3, 8, 6, 3, 1, 6, 8, 3, 6, 1, 3, 8, 1, 3, 8, 6, 1, 3, 8, 3, 6, 3, 1, 8, 3, 6, 8, 1, 3, 8, 3, 6, 8, 1, 3, 6, 8, 1, 3, 6, 8, 3, 6, 8, 3, 3, 6, 8, 1, 3, 6, 8, 3, 1, 8, 3]
    , [2, 7, 4, 2, 7, 2, 7, 2, 4, 7, 2, 7, 4, 2, 7, 4, 7, 2, 7, 4, 2, 7, 2, 4, 7, 2, 7, 4, 2, 7, 4, 2, 2, 7, 4, 2, 7, 2, 4, 7, 2, 4, 7, 2, 2, 7, 2, 4, 2, 7, 4, 2, 2, 7, 2, 7, 4, 2, 7, 2, 4, 2]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
]

// const reelSymbols = [
//     [0, 0, 0, 0, 0, 0, 0]
//     , [0, 0, 0, 0, 0, 0, 0]
//     , [0, 0, 0, 0, 0, 0, 0]
//     , [0, 0, 0, 0, 0, 0, 0]
//     , [0, 0, 0, 0, 0, 0, 0]
//     , [0, 0, 0, 0, 0, 0, 0]
// ]

export interface SymbolObject {
    symbolIndex: number // this is symbol position number in the array 0,1,2..
    id: number; // this is symbol id number mapped with backend
    y: number
    view: Container;
    symbol: Spine;
    isWin: boolean;
    multText: BitmapText;
    multVal: number;
}

export interface ReelObject {
    container: Container;
    reelIndex: number
    // reelCollections: Container[];
    symbols: SymbolObject[];
    // symbolSprites : Sprite[];
    // symbolPositions : number[];
    // position: number;
    // nextPosition: number;
    // time: number;
    settled: boolean;
    // blurFilter: BlurFilter;
    tween: Tween<any> | null;
}



export class ReelInit extends Container {

    public allReelArray: ReelObject[];
    public reelOverlayContainer: Container;
    public anticipation: Spine[];

    private allReelContainer: Container;

    public accWinValue: BitmapText = new BitmapText({
        text: "",
        style: {
            fontFamily: 'JoystixMonospace-Regular-Blue',
            fontSize: 50
        }
    });


    constructor() {
        super();
        this.allReelContainer = new Container();
        this.allReelArray = [];
        this.reelOverlayContainer = new Container();
        this.anticipation = [];

        // this.reelOverlayContainer.visible=false;

        this.initReels();

    }

    private initReels() {
        for (let i = 0; i < REEL_NUMBERS; i++) {
            const reelContainer = new Container();
            const reelObj: ReelObject = {
                container: reelContainer,
                reelIndex: i,
                // reelCollections: [],
                symbols: [],
                // symbolSprites: [],
                // symbolPositions: [],
                // position: 0,
                // nextPosition: 0,
                // time: 0,
                settled: true,
                // blurFilter: new BlurFilter(),
                tween: null
            };

            // reelObj.blurFilter.strength = 0;
            // reelContainer.filters = [reelObj.blurFilter];
            reelContainer.x = REEL_FRAME + i * (REEL_WIDTH + REEL_DIVIDER);
            reelContainer.y = REEL_FRAME;

            // reelContainer.visible = false;  // later make it enabled- > reels will be false

            // for (let k = 0; k < REEL_COLLECTION_COUNT; k++) {
            // const reelCollectionContainer = new Container();

            const reelRand = Math.floor(Math.random() * (reelSymbols[i].length - SYMBOLS_PER_REEL));
            let reelSymbolIds = RespinIndex.value === 0 ?
                reelSymbols[i].slice(reelRand, reelRand + SYMBOLS_PER_REEL)
                :
                spinData.respins[RespinIndex.value - 2].reelSymbols[i];

            if (Array.isArray(reelSymbolIds) && reelSymbolIds.every(num => typeof num === 'number')) {
                // console.log("reelSymbolIds is an array of numbers");
            } else {
                reelSymbolIds = reelSymbols[i].slice(reelRand, reelRand + SYMBOLS_PER_REEL)
            }

            if (reelSymbolIds)


                for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                    // const predefinedReelImageData = initData .reelSymbols ? initData.reelSymbols[i] : undefined;
                    // if (predefinedReelImageData) {
                    //     reelObj.symbols.id = predefinedReelImageData;
                    // }

                    // let symbol: Sprite;
                    // if (k == 0) {
                    //     const symbolId = Math.floor(Math.random() * NUMBER_OF_SYMBOLS);
                    //     symbol = Sprite.from(getSymbol(symbolId));
                    //     reelObj.symbols[j] = symbolId;
                    // } else {
                    //     // symbol = new Sprite(getSymbol(Math.floor(Math.random() * NUMBER_OF_SYMBOLS)));
                    //     symbol = new Sprite();

                    // }

                    const symbolContainer = new Container();

                    const symbolId = reelSymbolIds[j];
                    // let symbol = Sprite.from(getSymbol(symbolId));

                    let symbol = getSpineSymbol(symbolId);

                    symbolContainer.addChild(symbol);
                    // reelObj.symbols[j].id = symbolId;

                    // symbol.anchor = 0.5;
                    symbolContainer.y = (SYMBOL_HEIGHT / 2) + j * SYMBOL_HEIGHT;
                    symbolContainer.x = Math.round(SYMBOL_WIDTH / 2);

                    const textval = new BitmapText({
                        text: "",
                        style: {
                            fontFamily: 'sugar_multiplier',
                            fontSize: 80
                        }
                    });

                    textval.anchor = 0.5;
                    textval.position.set(0, 20);
                    symbolContainer.addChild(textval);

                    const symbolObj: SymbolObject = {

                        symbolIndex: j,
                        id: symbolId,
                        y: symbolContainer.y,
                        view: symbolContainer,
                        symbol: symbol,
                        isWin: false,
                        multText: textval,
                        multVal: 0,
                    }

                    reelObj.symbols.push(symbolObj);

                    reelContainer.addChild(symbolContainer);


                }

            // chnaging order of cells, making symbols on top of cells
            reelObj.symbols.forEach((symbol) => {
                reelContainer.addChild(symbol.view);
            })

            // reelContainer.addChild(reelCollectionContainer);
            // reelObj.reelCollections.push(reelCollectionContainer);
            // }

            this.allReelContainer.addChild(reelContainer);
            this.allReelArray.push(reelObj);

            this.anticipation[i] = Spine.from({
                skeleton: "anticipationSkel",
                atlas: "anticipationAtlas",
            });

            this.anticipation[i].x = REEL_FRAME + i * (REEL_WIDTH + REEL_DIVIDER);
            this.anticipation[i].y = REEL_FRAME;
        }


        const markOffset = 4;

        const reactMark = new Graphics().rect(REEL_FRAME, REEL_FRAME - markOffset, REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER, markOffset + SYMBOL_HEIGHT * SYMBOLS_PER_REEL).fill(0x950a5a);
        this.allReelContainer.addChild(reactMark);
        reactMark.alpha = .5;
        this.allReelContainer.mask = reactMark;

        // this.allReelContainer.scale=0.35;
        // this.allReelContainer.y = this.allReelContainer.y+100;

        this.addChild(this.allReelContainer);


        this.reelOverlayContainer.destroy();
        // this.reelOverlayContainer = new Container();

        this.initReelOverlayContainer();
        // for (let i = 0; i < REEL_NUMBERS; i++) {
        //     this.addReelSymbolsToContainer(i);
        // }


        this.accWinValue.position.set(280, -188)
        this.accWinValue.anchor = 0.5;
        this.addChild(this.accWinValue);



    }



    public initReelOverlayContainer() {
        this.reelOverlayContainer = new Container();
        this.reelOverlayContainer.x = this.allReelContainer.x;
        this.reelOverlayContainer.y = this.allReelContainer.y;

        this.addChild(this.reelOverlayContainer);
    }

    // public initReelOverlayContainer() {
    //     this.reelOverlayContainer = new Container();
    //     this.reelOverlayContainer.x = this.allReelContainer.x;
    //     this.reelOverlayContainer.y = this.allReelContainer.y;

    //     this.addChild(this.reelOverlayContainer);

    //     for (let i = 0; i < REEL_NUMBERS; i++) {
    //         this.reelOverlayContainer.addChild(this.anticipation[i]);
    //     }


    //     // comment 
    //     // this.reelOverlayContainer.scale=0.5;
    //     // this.reelOverlayContainer.x = this.allReelContainer.x + 600;
    //     // this.reelOverlayContainer.y = this.allReelContainer.y + 400;

    // }


    // public addReelSymbolsToContainer(reelNum: number) {
    //     const reelObj = this.allReelArray[reelNum];
    //     // reelObj.container.visible = false;

    //     for (let j = 0; j < reelObj.symbols.length; j++) {

    //         const symbolObj = reelObj.symbols[j];

    //         const posNum = j;

    //         const symbolId =symbolObj.id;



    //         const winSymbol = getSpineSymbol(symbolId);

    //         winSymbol.y = REEL_FRAME + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
    //         winSymbol.x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER);
    //         winSymbol.label = `${reelNum * 3 + posNum}`;

    //         // console.log(`symbolId ${symbolId} reelNum ${reelNum } posNum ${ posNum}`);

    //         // if (!this.reelOverlayContainer.getChildByName(`${reelNum * 3 + posNum}`)) {
    //         //     this.reelOverlayContainer.addChild(winSymbol);
    //         // }

    //         // const existingSymbol = this.reelOverlayContainer.getChildByName(`${reelNum * 3 + posNum}`);
    //         // if (existingSymbol) {
    //         //     this.reelOverlayContainer.removeChild(existingSymbol)
    //         //     existingSymbol.destroy();
    //         // }

    //         // this.reelOverlayContainer.addChild(winSymbol);


    //     }

    //     // check for oversized symbols
    //     for (let i = 0; i <= reelNum; i++) {
    //         const currentReelObj = this.allReelArray[i];
    //         for (let j = 0; j < currentReelObj.symbols.length; j++) {
    //             const posNum = j;
    //             const symbolId = currentReelObj.symbols[posNum].id;
    //             if (isOversizeSymbol(symbolId)) { // symbolId of oversized symbols
    //                 const winSymbol: Spine | null = this.reelOverlayContainer.getChildByName(`${i * 3 + posNum}`) as Spine;
    //                 if (winSymbol) {
    //                     this.reelOverlayContainer.addChild(winSymbol);
    //                 }
    //             }
    //         }
    //     }
    // }



    // public addSymbolOverlayContainer (symbol : Spine, reelNum: number, posNum : number) {

    //     const winSymbol = symbol;

    //     winSymbol.y = REEL_FRAME + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
    //     winSymbol.x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER);
    //     winSymbol.label = `${reelNum * 3 + posNum}`;

    //     const existingSymbol = this.reelOverlayContainer.getChildByName(`${reelNum * 3 + posNum}`);
    //     if (existingSymbol) {
    //         this.reelOverlayContainer.removeChild(existingSymbol)
    //         existingSymbol.destroy();
    //     }

    //     this.reelOverlayContainer.addChild(winSymbol);

    //     this.resetWinContainer();

    // }

    // public resetWinContainer() {

    //     // this.allReelArray[reelNum].container.visible = false;
    //     for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {

    //         for (let j = 0; j < this.allReelArray[reelNum].symbols.length; j++) {


    //             const posNum = j;

    //             // console.log(`reelNum ${reelNum}`);
    //             // console.log(`posNum ${posNum}`);

    //             const symbolId: number = this.allReelArray[reelNum].symbols[posNum].id;
    //             const winSymbol = getSpineSymbol(symbolId);

    //             winSymbol.y = REEL_FRAME + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
    //             winSymbol.x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER);

    //             winSymbol.label = `${reelNum * 3 + posNum}`;

    //             if (this.reelOverlayContainer.getChildByLabel(`${reelNum * 3 + posNum}`)) {
    //                 //do nothing
    //             }
    //             else {
    //                 this.reelOverlayContainer.addChild(winSymbol)
    //             }


    //         }
    //     }

    //     // check for oversize symbols
    //     for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {

    //         for (let i = 0; i <= reelNum; i++) {
    //             const currentReelNum = i;
    //             for (let j = 0; j < this.allReelArray[currentReelNum].symbols.length; j++) {

    //                 const posNum = j;

    //                 const symbolId: number = this.allReelArray[currentReelNum].symbols[posNum].id;

    //                 if (isOversizeSymbol(symbolId)) // symbolId of oversized symbols
    //                 {
    //                     const winSymbol: Spine | null = this.reelOverlayContainer.getChildByLabel(`${currentReelNum * 3 + posNum}`) as Spine;
    //                     this.reelOverlayContainer.addChild(winSymbol)
    //                 }

    //             }
    //         }
    //     }
    // }


}
